module.exports = __webpack_public_path__ + "files/dc2c39658a399a2df4e4ea4dd0c72f9b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-bold-webfont.svg
 ** module id = 1022
 ** module chunks = 0
 **/